"use client";

import { useEffect } from "react";

import { ErrorState } from "@/components/error/ErrorState";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorState
      title="Something went wrong"
      description="We hit a snag while loading this page."
      details={
        <p>
          Please try reloading the page. If the issue keeps coming up, let us know so we can sort it
          out.
        </p>
      }
      actions={[
        {
          label: "Try again",
          onClick: () => reset(),
        },
        {
          label: "Go to home",
          href: "/",
          variant: "ghost",
        },
      ]}
    />
  );
}
